<script>
  import { Card } from 'attractions'
</script>

<Card outline>
  <div class="api command">addMoveCommand(int steps[, string direction])</div>
  Moves the robot on the playing surface.
  <p>
    The robot will move in the specified direction for the specified number of steps. The direction must be either
    <strong>forward</strong> or <strong>backward</strong>. If no direction is specified, the robot will move forward.
  </p>
  <div class="api title">Arguments:</div>
  <ul>
    <li>
      <strong>steps</strong> &mdash; An integer value between 1 and 100, inclusive, for the number of steps to move the robot.
    </li>
    <li>
      <strong>direction</strong> <em>(optional)</em> &mdash; A string to represent the direction in which to move the robot.
    </li>
  </ul>
  <div class="api title">Constraints:</div>
  <ul>
    <li>The number of steps must be a positive integer between 1 and 100.</li>
    <li>The direction must be either <strong>forward</strong>, the default, or <strong>backward</strong>.</li>
  </ul>
  <div class="api title">Example:</div>
  <div class="api code">
    <pre>
      robot.addMoveCommand(1); /* Moves the robot forward 1 step */
      robot.addMoveCommand(10, "backward"); /* Moves the robot backward 10 steps */
    </pre>
  </div>
</Card>
